<ngx-dropzone
    #drop
    class="mb-5"
    [accept]="acceptedFileTypes"
    [multiple]="false"
    [disableClick]="false"
    [disabled]="$any(fileUploaderService.disabled$ | ngrxPush)"
    (change)="onAddFiles($event)"
>
    <ngx-dropzone-label>
        <ng-container>
            <div class="text-center body-text-medium">
                <div>Drag and drop your file here</div>
                <div>or</div>
            </div>
            <div class="d-flex justify-content-center">
                <button class="mx-1" [wdxButton]="WDX_BUTTON_STYLE.Link">
                    Browse
                </button>
            </div>
        </ng-container>
    </ngx-dropzone-label>
</ngx-dropzone>

@for (file of acceptedFiles; track $index; let i = $index) {
    <ngb-progressbar
        height=".5rem"
        [type]="
            (fileUploaderService.errorUploadingFile$ | ngrxPush)
                ? 'error'
                : (fileUploaderService.uploadedFile$ | ngrxPush)
                  ? 'success'
                  : 'info'
        "
        [value]="$any(fileUploaderService.uploadProgress$) | ngrxPush"
    ></ngb-progressbar>

    <wdx-info-card
        [class.card-danger]="fileUploaderService.errorUploadingFile$ | ngrxPush"
        [wdxIsLoading]="(fileUploaderService.fileEvent$ | ngrxPush)!"
        [loadingOverlay]="true"
    >
        <div wdxInfoCardLeading class="separator">
            <wdx-icon-container class="bg-icon" size="lg">
                <wdx-icon icon="file"></wdx-icon>
            </wdx-icon-container>
        </div>

        <div wdxInfoCardLabel>
            {{ file.name }}
        </div>

        <div wdxInfoCardSub>
            {{ file.type }} <b>{{ file.size | fileSize }}</b>

            @if (
                fileUploaderService.uploadedFile$ | ngrxPush;
                as uploadedFile
            ) {
                <ul class="mt-2">
                    <li>
                        Records found:
                        <b>{{ uploadedFile.recordsFound }}</b>
                    </li>
                    <li>
                        Source environment:
                        <b>{{ uploadedFile.sourceEnvironment }}</b>
                    </li>
                    <li>
                        Source Source tenant:
                        <b>{{ uploadedFile.sourceTenant }}</b>
                    </li>
                    <li>
                        Target tenant:
                        <b>{{ uploadedFile.targetTenant }}</b>
                    </li>
                </ul>

                <div class="form-check">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        (change)="onCheckboxChange($event)"
                    />
                    <label>
                        <p>Overwrite Local Changes</p>
                    </label>
                </div>
            }
        </div>

        <div wdxInfoCardTrailing>
            @if (
                fileUploaderService.uploadedFile$ | ngrxPush;
                as uploadedFile
            ) {
                <button
                    class="me-1"
                    title="execute"
                    size="sm"
                    [wdxIconButton]="true"
                    (click)="onFileEvent('execute')"
                >
                    <wdx-icon-container size="sm">
                        <wdx-icon [icon]="ICONS.check"></wdx-icon>
                    </wdx-icon-container>
                </button>

                <button
                    title="abort"
                    size="sm"
                    [wdxIconButton]="true"
                    (click)="onFileEvent('abort')"
                >
                    <wdx-icon-container size="sm">
                        <wdx-icon [icon]="ICONS.close"></wdx-icon>
                    </wdx-icon-container>
                </button>
            }
        </div>
    </wdx-info-card>
}
